import { isAuthErrorStatus } from '@doneverse/data/api'

export function hasProtectedRouteAuthFailure(params: {
  loading: boolean
  hasUser: boolean
  hasProfile: boolean
  authErrorStatus: number | null
}): boolean {
  if (params.loading) return false
  if (!params.hasUser || params.hasProfile) return false
  return isAuthErrorStatus(params.authErrorStatus)
}

export function createStatusError(message: string, status: number): Error & { status: number } {
  const error = new Error(message) as Error & { status: number }
  error.status = status
  return error
}
